module.exports = __webpack_public_path__ + "img/x-mark.46b58526.svg";